import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { SEND_MAIL_MESSAGE } from "../mail-message.queries";
import { parseParams } from "../../../helpers/clean-object";

import { SendMailMessageInput } from "../../../__generated__/globalTypes";
import {
  SendMailMessageMutation,
  SendMailMessageMutationVariables,
} from "../../../__generated__/SendMailMessageMutation";

interface IProps {
  defaultValues: DeepPartial<SendMailMessageInput>;
  onCompleted: (id?: number | null) => any;
}

export const useSendMailMessage = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<SendMailMessageInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    SendMailMessageMutation,
    SendMailMessageMutationVariables
  >(SEND_MAIL_MESSAGE, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.sendMailMessage?.ok) {
        toast.success("Email envoyé avec succès");
        onCompleted(data.sendMailMessage.id);
      } else {
        throw Error(data?.sendMailMessage?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
